import { Chip } from '@mui/material';

import { InvoiceStatus } from './types';

export default function StatusChip({ status }: Readonly<{ status: InvoiceStatus }>) {
    const config: Record<InvoiceStatus, { label: string; bg: string; color: string }> = {
        paid: { label: 'Paid', bg: 'success.lightHover', color: 'success.dark' },
        unpaid: { label: 'Unpaid', bg: 'cement.100', color: 'cement.900' },
        overdue: { label: 'Overdue', bg: 'error.lightHover', color: 'error.main' },
        draft: { label: 'Draft', bg: 'grey.100', color: 'text.secondary' },
    };
    const c = config[status];
    return <Chip size="small" label={c.label} sx={{ bgcolor: c.bg, color: c.color, fontWeight: 600, height: 22 }} />;
}
